import { PropsWithChildren } from 'react'
import { useContentfulContext } from './ContentfulContext'
import { Button, Icon, Popover, PopoverContent, PopoverLauncher, tokens } from '@vp/swan'
import { areContentfulLinksEnabled, getContentfulLink, isBrowser, validateContentfulContext, validateContentfulMetadata } from './utils'

type ContentfulLinkProps = {
  id: string
}

export const ContentfulLink : React.FC<PropsWithChildren<ContentfulLinkProps>> = ({ children, id }) => {
  const contentfulContext = useContentfulContext()
  const enoughInfo = validateContentfulContext(contentfulContext) && validateContentfulMetadata({ contentful_id: id, contentfulName: 'NOT_USED' })

  if (!isBrowser() || !areContentfulLinksEnabled() || !enoughInfo) {
    return (
      <>
        {children}
      </>
    )
  }

  const entryUrl = getContentfulLink(contentfulContext, id)

  return (
    <div style={{ position: 'relative' }}>
      <Popover style={{ position: 'absolute', left: tokens.SwanSemSpace5, top: tokens.SwanSemSpace5, zIndex: tokens.SwanSemZIndexOverTheTop }}>
        <PopoverLauncher>
          <Button><Icon src={imageUrl} /></Button>
        </PopoverLauncher>
        <PopoverContent><a href={entryUrl} target='_blank' rel='noreferrer'>Go to contentful entry</a></PopoverContent>
      </Popover>
      {children}
    </div>
  )
}

const imageUrl = 'https://cms.cloudinary.vpsvc.com/image/upload/c_scale,w_24/v1726830243/page_icons/logos/contentful.png'
